/* eslint-disable no-console */
import { IApiRequest } from '@/hooks/api/useApi/useApi.interfaces';
import { setAuthCookie } from '@packages/authenticator/cookie';

interface IHeaders extends RequestInit {
    'Content-Type'?: string;
    'X-Locale': string;
    Authorization?: string;
    'x-authorization-new'?: string;
}

// NEW LANGUAGE
const LanguageToXLocale: Record<string, string> = {
    pl: 'pl',
    sk: 'sk_SK',
    cs: 'cs_CZ',
    en: 'en_GB',
};

export async function apiFetcher<response>(request: IApiRequest, language: string, token?: string): Promise<response> {
    const config = {
        url: `${process.env.API_URL || ''}${request.url}${request.query || ''}`,
        method: request.method,
        body: request.body || undefined,
        contentType: request.contentType || 'application/json',
    };

    const headers = createApiHeaders(request, language, token);

    const requestConfig = createRequestConfig(config, headers);

    try {
        const response = await fetch(config.url, requestConfig as unknown as RequestInit);
        const body = await response.json();

        handleResponseHeaderToken(response);

        return {
            success: response.status >= 200 && response.status < 300,
            status: response.status,
            ...body,
        };
    } catch (error) {
        console.error(error);
        return {
            success: false,
            status: 500,
        } as response;
    }
}

const createRequestConfig = (request: IApiRequest, headers: object) => {
    const requestConfig = {
        headers,
        method: request.method,
        contentType: request.contentType,
        body: request.body ? prepareDataToSend(request) : undefined,
    };

    return removeUndefinedProperties(requestConfig);
};

const createApiHeaders = (request: IApiRequest, language: string, token?: string): IHeaders => {
    const headers = {
        'X-Locale': LanguageToXLocale[language],
        'Content-Type': request.contentType === 'multipart/form-data' ? undefined : 'application/json',
        Authorization: token ? `Bearer ${token}` : undefined,
    };

    return removeUndefinedProperties<IHeaders>(headers);
};

const prepareDataToSend = (request: IApiRequest) => {
    if (request.contentType === 'multipart/form-data' && request.body) {
        return objectToFormData(request.body);
    }

    return JSON.stringify(request.body);
};

const objectToFormData = (obj: object) => {
    const formData = new FormData();

    Object.entries(obj).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((item: string) => {
                formData.append(`${key}[]`, item);
            });

            return;
        }
        formData.append(key, value as string);
    });

    return formData;
};

function removeUndefinedProperties<returnType>(obj: object) {
    return Object.entries(obj).reduce((acc: { [key: string]: string }, [key, value]) => {
        if (value !== undefined) {
            acc[key] = value;
        }

        return acc;
    }, {}) as returnType;
}

export const handleResponseHeaderToken = (response: Response) => {
    const responseHeaderToken = response.headers.get('x-authorization-new');

    if (responseHeaderToken) {
        setAuthCookie(responseHeaderToken);
    }
};
